import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import Header from './modules/_header.js';
import Flyout from './modules/_flyout.js';

import './modules/_video-slider.js';
import './modules/_tile-card.js';
import './base/_object-fit-cover.js';

class Scripts {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();

		document.addEventListener( 'click', this.listenForChat.bind(this) );
	}

	ready() {
		focusWithin( 'label, form, fieldset' );

		this.header = new Header();
		this.flyout = new Flyout();

		this.header.hamburger.addEventListener('click', () => this.flyout.open('menu'));
		this.header.search.addEventListener('click', () => this.flyout.open('search'));
	}

	resize() {
		if ( ! document.body ) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}

	chat( chatURL ) {
		let path = window.location.pathname;
		let page = path.split("/").pop();
		page = page.split(".")[0];
		chatURL += "&WebSiteID=" + page;
		window.open( chatURL, 'iceIMen', 'width=490, height=760, resizable=yes, scrollbars=yes' );
	}

	listenForChat(e) {
		let node = e.target;

		while( node && node.parentNode ) {
			if ( node.tagName === 'A' && node.href.match(/^https?:\/\/(www\.)?firstcitizens.chat\/?/) ) {
				e.preventDefault();
				this.chat( node.href );
				return;
			}

			node = node.parentNode;
		}
	}

}

export default new Scripts;
